import script from "./FaceRecognition.vue?vue&type=script&setup=true&lang=js"
export * from "./FaceRecognition.vue?vue&type=script&setup=true&lang=js"

import "./FaceRecognition.vue?vue&type=style&index=0&id=57391f49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57391f49"]])

export default __exports__